import defaultApi from '@/utils/request';

export default {
  load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_Role/Load',
      params,
    });
  },
  get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_Role/Get',
      params,
    });
  },
  add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_Role/Add',
      data,
    });
  },
  update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_Role/Update',
      data,
    });
  },
  del(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_Role/Delete',
      data,
    });
  },
};
